/* eslint-disable complexity, max-statements, max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapActions, mapState } from "vuex";
import config from "../../../../../share/config";
import session from "../../../../../share/session";

import individualDiagnose from "../../../../../share/util/individualDiagnose";
import dataConversion from "../../../../../share/util/didDataConversion";
import cstmTable from "../../../../vue/individualActiveTest/activeTestControlPanel/ControlPanelTable";
import atUtil from "../../../../pages/individualActiveTest/individualActiveTestUtil";
import loading from "../../../../../share/components/vue/ProcessingIcon";
import { fixNumberWithDecimal } from "../../../../../common/nodejs/mathFunctions";

import {
  API_TYPE,
  DATA_TYPE,
  ERR_KEY,
  ERR_TYPE,
  FLOW,
  FLOW_ERROR,
  MNTR_STATUS,
  //  NRC_CODE,
  RES_TYPE,
  I18N_PARENT_ID,
  HEX_PREFIX,
  AT_EXE_TYPE
} from "../../../../pages/individualActiveTest/individualActiveTestConstants.js";

const PARAM = {
  DID: "did",
  TITLE: "menu_title",
  TYPE: "data_type",
  BYTE_SIZE: "byte_size",
  LITTLE_ENDIAN: "little_endian",
  OPERATION_RULES: "operations_rules",
  REQUEST_RESULT: "request_result",
};

const MENUS = {
  ATID: "active_test_id",
  REQID: "requirement_id",
  TITLEID: "title_id",
  VALS: "values",
  SID22: "sid0x22",
  SID2E2F: "sid0x2E_sid0x2F",
  CTRL_STT: "control_state",
  DID: "did",
  VAL: "value",
  RID: "rid",
  EXE_MNTR_TERMINATE: "execution_monitoring_terminate_condition",
  EXE_MNTR_CONTINUE: "execution_monitoring_continuate_condition",
  STOP_MNTR_TERMINATE: "stop_monitoring_terminate_condition",
  STOP_MNTR_CONTINUE: "stop_monitoring_continuate_condition",
};

const AT_EXE = {
  STATUS: "status",
  MNTR_STATUS: "monitoring_status",
  USER_DATA: "user_data",
  RES_TYPE: "res_type",
  VAL: "value",
};

export default {
  name: "requirementSp7",
  data() {
    return {
      /** 状態遷移 */
      flow: FLOW.INIT,
      columns: [],
      // 変換情報
      conversionInfoList: [],
      items: [],
      /** AT文言 */
      message: "",
      /** 停止中フラグ */
      isStopping: false,
      updateItems: {},
      updateSwitchModeValues: {},
      stopItems: {},
      autoSwitchModeDids: [],
      isDriving: false,
      datas: null,
      atMsgResult: null,
      displayProcessing: false,
      drvBtnDisabled: true,
      currentExecuteTime: null,
      latestUpdateTime: null,
      // サインアウト
      signout: false,
    };
  },

  props: {
    selectedAtFunc: { type: Object, required: true },
    //    message: { type: String, default: "", required: false },
    inExecution: { type: Boolean, required: true },
  },

  components: {
    "processing-view": loading,
    "cstm-table": cstmTable,
  },

  watch: {
    language: {
      handler() {
        // 言語選択時、ヘッダーと計測項目一覧を更新
        this.setColumns();
        this.setItems(this.datas, false);
        this.setAtMessage();
      },
    },

    datas: {
      handler(values) {
        this.setItems(values);
      },
    },

    atMsgResult: {
      handler() {
        this.setAtMessage();
      }
    },

    isDriving: {
      immediate: true,
      handler(value) {
        this.$emit("notify-change-drive", value);
      }
    },
  },

  computed: {
    ...mapState({
      language: (state) => state.systems.language,
      netAppId: (state) => state.netAppConnector.pairingAppId,
      individualMenus: state => state.vehicle.individualMenus,
    }),
    systemId() {
      return individualDiagnose.getCurrentSystemId(this);
    },
    activeTestId() {
      return this.selectedAtFunc[MENUS.ATID];
    },
    requirementId() {
      return this.selectedAtFunc[MENUS.REQID];
    },
    ridList() {
      return this.selectedAtFunc[MENUS.RID];
    },
    controlStateList() {
      return this.selectedAtFunc[MENUS.CTRL_STT];
    },
    uiid() {
      return this.selectedAtFunc[MENUS.ATID].slice(0, -2);
    },
    isDriveFlow() {
      return [FLOW.EXECUTE, FLOW.CHECK_EXE].includes(this.flow);
    },
    isExecuteFlow() {
      return [FLOW.STANDBY, FLOW.CHECK_EXE].includes(this.flow);
    },

    selectedAtFuncTitle() {
      const titleRefIdKey = `at${this.systemId}.${this.uiid}.menu_title_ref`;
      if (!this.$te(titleRefIdKey)) {
        return this.selectedAtFunc[PARAM.TITLE];
      }
      const titleRefId = this.$t(titleRefIdKey);
      const title_key = `at${this.systemId}.${I18N_PARENT_ID}.${PARAM.TITLE}_${titleRefId}`;
      if (!this.$te(title_key)) {
        return this.selectedAtFunc[PARAM.TITLE];
      }
      return this.$t(title_key);
    },

    driveBtnLabel() {
      return this.$t("individual.button_active_test_drive");
    },

    btnDisabled() {
      const disabled = {
        ac: false,
      };
      return disabled;
    },
  },

  methods: {
    ...mapActions("auth", ["logout", "resetSession"]),

    /**
     * AT項目選択ボタンクリック時の処理
     * AT項目選択 → DM項目選択 遷移時に行う処理を記述する
     */
    async btnAtSelectOnClicked() {
      this.displayProcessing = true;
      this.drvBtnDisabled = true;
      this.flow = FLOW.INIT;
      await this.loadData();
      this.displayProcessing = false;
    },

    /** データ読み出し処理 */
    async loadData() {
      // データ読み出し実行フラグをfalseに切り替え
      this.$emit("toggle-read-executed", false);

      this.didList = {};
      const activeTestIds = [];

      this.selectedAtFunc.values.forEach((ar0) => {
        ar0.forEach((elm0) => {
          activeTestIds.push(elm0.active_test_id);
          if ((!elm0.sid0x22) || (elm0.sid0x22.length === 0)) {
            return;
          }
          elm0.sid0x22.forEach((did) => {
            if (Object.keys(this.didList).indexOf(did) < 0) {
              this.didList[did] = elm0;
            }
          });
        });
      });

      // データ読み出し
      const dataRes = await atUtil.doRead(this, Object.keys(this.didList), 5 * 60);
      if ((!dataRes) || (!dataRes.data[AT_EXE.USER_DATA])) {
        this.clearAtMsg();
        this.displayInit();
        return;
      }
      const convRes = await atUtil.getATConversion(this, activeTestIds);
      if (!convRes) {
        // 共通エラーへ遷移
        this.flow = FLOW.ERR;
        this.doErrorProcess(ERR_KEY.COMMON);
        this.clearAtMsg();
        this.$emit("toggle-drive", false);
        return;
      }
      this.conversionInfoList = convRes.data.conversion_list;

      // データ読み出し実行フラグをtrueに切り替え
      this.$emit("toggle-read-executed", true);

      this.datas = dataRes.data[AT_EXE.USER_DATA];
    },

    /** 
     * 値を指定範囲内に変換する
     * @param {number} val 変換対象の値
     * @param {object} operations_rules 変換ルール
     * @returns {number} 変換後の値
     */
    convInRangeValue(val, operations_rules) {
      if (!operations_rules) {
        return val;
      }

      if ("min" in operations_rules) {
        if (Number(val) < Number(operations_rules.min)) {
          return operations_rules.min;
        }
      }
      if ("max" in operations_rules) {
        if (Number(val) > Number(operations_rules.max)) {
          return operations_rules.max;
        }
      }
      return val;
    },

    /** 
     * 値を指定範囲内に変換する（16進数）
     * @param {string} val 変換対象の値
     * @param {object} operations_rules 変換ルール
     * @returns {string} 変換後の値
     */
    convInRangeHex(val, operations_rules) {
      if (!operations_rules) {
        return val;
      }
      if ("min" in operations_rules) {
        if (parseInt(val, 16) < parseInt(operations_rules.min, 16)) {
          return operations_rules.min;
        }
      }
      if ("max" in operations_rules) {
        if (parseInt(val, 16) > parseInt(operations_rules.max, 16)) {
          return operations_rules.max;
        }
      }
      return val;
    },

    /**
     * アイテムの設定
     * @param {Array} datas データ配列
     * @param {Boolean} clearUpdate 更新フラグをクリアするかどうか
     */
    setItems(datas, clearUpdate = true) {
      if (!datas || (datas.length === 0)) {
        return;
      }

      const self = this;

      if (!self.didList) {
        return;
      }

      if (clearUpdate) {
        self.flow = FLOW.STANDBY;
        self.updateItems = {};
        self.drvBtnDisabled = true;
      }

      self.didValues = {};
      Object.keys(self.didList).forEach((d) => {
        if (!(d in self.didValues)) {
          self.didValues[String(parseInt(d.split("_")[0], 16))] = d;
        }
      });

      const items = [];
      self.selectedAtFunc.values.forEach((ar0) => {
        ar0.forEach((fnc) => {
          let dataIdx = -1;
          fnc.sid0x22.some((did0) => {
            return datas.some((d, i) => {
              const rc = (d.id === parseInt(did0.slice(0, 4), 16));
              if (rc) {
                dataIdx = i;
              }
              return rc;
            });
          });

          if (dataIdx < 0) {
            const elm0 = fnc;
            if ((!!elm0.sid0x22) && (elm0.sid0x22.length > 0)) {
              return;
            }
            if (!elm0.sid0x2E_sid0x2F) {
              return;
            }
            if ((elm0.active_test_id !== "70501") && (elm0.active_test_id !== "72001")) {
              return;
            }

            const uiid = elm0.active_test_id.slice(0, -2);
            const item_name_r = "at" + self.systemId + "." + uiid + ".item_name";
            const display_name_r = "at" + self.systemId + "." + uiid + ".display_name";
            const item_name = self.$te(item_name_r) ? self.$t(item_name_r) : item_name_r;
            const display_name = self.$te(display_name_r) ? self.$t(display_name_r) : display_name_r;

            elm0.sid0x2E_sid0x2F.forEach((did) => {
              items.push({
                id: did,
                menu_title: item_name,
                value: "",
                unit: "-",
              });
              if (self.autoSwitchModeDids.indexOf(did) < 0) {
                self.autoSwitchModeDids.push(did);
                self.updateSwitchModeValues[did] = display_name;
              }
            });

            return;
          }

          const d = datas[dataIdx];
          let val = 0.0;
          let siVal = 0.0;
          let value = "";
          let unit = "-";
          const did = self.didValues[String(d.id)];

          const conv = self.conversionInfoList.find((x) => x.did === did);
          if ((!!conv) && ("info" in conv)) {
            if (!clearUpdate) {
              const item = self.items.find((x) => x.id === did);
              if ((item !== undefined) && (item !== null)) {
                val = item.num_val;
                siVal = item.si_val;
              }
            } else {
              let commValue = "";
              if (d.res_type === "ok") {
                commValue = d.value.slice(6);
              } else {
                const byteSize = conv.info.byte_or_bit === "byte"
                  ? conv.info.byte_size
                  : Math.ceil(conv.info.bit_size / 8);
                commValue = "0".repeat(byteSize * 2);
              }
              if (("data_type" in conv.info) && (conv.info.data_type === DATA_TYPE.VAL)) {
                siVal = Number(atUtil.convCtrlStateValueForSI(commValue, conv));
              } else if (("data_type" in conv.info) && ((conv.info.data_type === DATA_TYPE.FLG) ||
                (conv.info.data_type === DATA_TYPE.HEX))) {
                val = parseInt(atUtil.convCtrlStateValue(commValue, conv), 16);
              }
            }

            if (("data_type" in conv.info) && (conv.info.data_type === DATA_TYPE.VAL)) {
              siVal = self.convInRangeValue(siVal, conv.info.operations_rules);
              // SI単位系の値を元にUS単位に変換する
              val = dataConversion.convertUnitValueData(siVal, conv.info);
              if (conv.info.digit_after_decimal) {
                value = fixNumberWithDecimal(Number(val), conv.info.digit_after_decimal);
                siVal = fixNumberWithDecimal(Number(siVal), conv.info.digit_after_decimal);
              } else {
                value = fixNumberWithDecimal(Number(val), 0);
                siVal = fixNumberWithDecimal(Number(siVal), 0);
              }
              val = Number(value);
              siVal = Number(siVal);
              self.didList[did].i18n = self.getDidI18nList(conv);
            } else if (("data_type" in conv.info) && (conv.info.data_type === DATA_TYPE.FLG)) {
              self.didList[did].i18n = self.getDidI18nList(conv);
              value = (Number(val) === self.didList[did].i18n.values[0].val) ?
                self.didList[did].i18n.values[0].label : self.didList[did].i18n.values[1].label;
            } else if (("data_type" in conv.info) && (conv.info.data_type === DATA_TYPE.HEX)) {
              self.didList[did].i18n = self.getDidI18nList(conv);
              let v = self.didList[did].i18n.values.find((x) => x.val === val);
              if ((v === undefined) || (v === null)) {
                let maxVal = null;
                let maxIdx = null;
                self.didList[did].i18n.values.forEach((x, i) => {
                  if (maxVal === null) {
                    maxVal = x.val;
                    maxIdx = i;
                  } else {
                    if (maxVal < x.val) {
                      maxVal = x.val;
                      maxIdx = i;
                    }
                  }
                });
                if ((maxVal !== null) && (maxVal < val)) {
                  v = self.didList[did].i18n.values[maxIdx];
                } else {
                  v = self.didList[did].i18n.values[0];
                }
              }
              value = v.label;
            }
            unit = this.$t(`didUnit.` + conv.info.unit_id);
          } else {
            if (d.res_type === "ok") {
              value = d.value.slice(6);
              val = 0;
            }
          }

          const uiid = self.didList[did].active_test_id.slice(0, -2);
          const item_name_r = "at" + self.systemId + "." + uiid + ".item_name";
          const item_name = self.$te(item_name_r) ? self.$t(item_name_r) : item_name_r;

          items.push({
            id: did,
            menu_title: item_name,
            value: value,
            unit: unit,
            num_val: val,
            si_val: siVal
          });
        });
        return;
      });

      self.items = items;
    },

    /**
     * sid0x22に対応するsid0x2E_sid0x2Fを取得する
     * @param {string} sid0x22Did - sid0x22のDID
     * @returns {string|null} sid0x2E_sid0x2FのDID
     */
    get_sid0x2E_sid0x2F_from_sid0x22(sid0x22Did) {
      // sid0x22に対応するsid0x2E_sid0x2Fから変換情報のoperations_rulesを取得
      let sid0x2E_sid0x2F_did = null;
      this.selectedAtFunc.values.some((ar0) => {
        let sid0x2E_sid0x2F = [];
        const rc = ar0.some((elm0) => {
          const rc = elm0.sid0x22.some((did) => {
            if (did !== sid0x22Did) {
              return false;
            }
            sid0x2E_sid0x2F = elm0.sid0x2E_sid0x2F;
            return true;
          });
          return rc;
        });
        if (!rc) {
          return rc;
        }
        sid0x2E_sid0x2F_did = sid0x2E_sid0x2F[0];
        return rc;
      });
      return sid0x2E_sid0x2F_did;
    },

    /**
     * 項目の更新
     * @param {Object} data 値を変更した項目の情報
     * @param {Boolean} increase 値の増加か否か
     * @param {Number} rate 増減倍率
     */
    updateItem(data, increase = true, rate = 1) {
      const self = this;

      const autoSwitchModeDid = self.autoSwitchModeDids.find((target) => (target === data.id));
      if (autoSwitchModeDid) {
        if (data.value === "") {
          self.updateItems[data.id] = {
            name: data.menu_title,
            upd: 255,
            org: 0,
          };
          const item = self.items.find((x) => (x.id === data.id));
          item.value = self.updateSwitchModeValues[data.id];
        }
      } else {
        const conv = self.conversionInfoList.find((x) => x.did === data.id);
        if ((!conv) || (!("info" in conv))) {
          return;
        }

        if ((!("data_type" in conv.info)) || ((conv.info.data_type !== DATA_TYPE.VAL) &&
          (conv.info.data_type !== DATA_TYPE.FLG) && (conv.info.data_type !== DATA_TYPE.HEX))) {
          return;
        }

        const item = self.items.find((x) => (x.id === data.id));
        let val = item.num_val;
        let value = null;
        let siVal = item.si_val;

        if (("data_type" in conv.info) && (conv.info.data_type === DATA_TYPE.VAL)) {
          if (!("step" in conv.info.operations_rules)) {
            return;
          }
          const step = Number(conv.info.operations_rules.step);
          if (increase) {
            siVal += (step * rate);
          } else {
            siVal -= (step * rate);
          }
          siVal = self.convInRangeValue(siVal, conv.info.operations_rules);
          // SI単位系の値を元にUS単位に変換する
          val = dataConversion.convertUnitValueData(siVal, conv.info);
          if (conv.info.digit_after_decimal) {
            value = fixNumberWithDecimal(Number(val), conv.info.digit_after_decimal);
            siVal = fixNumberWithDecimal(Number(siVal), conv.info.digit_after_decimal);
          } else {
            value = fixNumberWithDecimal(Number(val), 0);
            siVal = fixNumberWithDecimal(Number(siVal), 0);
          }
          val = Number(value);
          siVal = Number(siVal);
        } else if (("data_type" in conv.info) && (conv.info.data_type === DATA_TYPE.FLG)) {
          value = item.value;
          const currentIndex = (val === 0) ? 0 : 1;
          if (increase) {
            if ((self.didList[conv.did].i18n.values.length - 1) > currentIndex) {
              value = self.didList[conv.did].i18n.values[currentIndex + 1].label;
              val = self.didList[conv.did].i18n.values[currentIndex + 1].val;
              val = (val === 0) ? 0 : 255;
            }
          } else {
            if (0 < currentIndex) {
              value = self.didList[conv.did].i18n.values[currentIndex - 1].label;
              val = self.didList[conv.did].i18n.values[currentIndex - 1].val;
              val = (val === 0) ? 0 : 255;
            }
          }
        } else if (("data_type" in conv.info) && (conv.info.data_type === DATA_TYPE.HEX)) {
          value = item.value;
          const currentIndex = self.didList[conv.did].i18n.values.findIndex((x) => (val === x.val));
          if (increase) {
            if ((self.didList[conv.did].i18n.values.length - 1) > currentIndex) {
              value = self.didList[conv.did].i18n.values[currentIndex + 1].label;
              val = self.didList[conv.did].i18n.values[currentIndex + 1].val;
            }
          } else {
            if (0 < currentIndex) {
              value = self.didList[conv.did].i18n.values[currentIndex - 1].label;
              val = self.didList[conv.did].i18n.values[currentIndex - 1].val;
            }
          }
        }

        if (!(data.id in self.updateItems)) {
          const org = item.num_val;
          if (org !== val) {
            self.updateItems[data.id] = {
              upd: val,
              org: org,
              siVal: siVal
            };
          }
        } else {
          if (self.updateItems[data.id].org !== val) {
            self.updateItems[data.id].upd = val;
            self.updateItems[data.id].siVal = siVal;
          } else {
            delete self.updateItems[data.id];
          }
        }

        item.value = value;
        item.num_val = val;
        item.si_val = siVal;
      }

      if (Object.keys(self.updateItems).length > 0) {
        if (self.updateItems.length <= 0) {
          self.drvBtnDisabled = true;
          self.latestUpdateTime = null;
        } else {
          self.drvBtnDisabled = false;
          self.latestUpdateTime = Date.now();
        }
      } else {
        self.drvBtnDisabled = true;
        self.latestUpdateTime = null;
      }
    },

    /** AT文言の削除 */
    clearAtMsg() {
      this.message = "";
    },

    /**
     * 左矢印ボタン押下時の処理
     * @param {Object} data 値を変更した項目の情報
     */
    handleLeftBtnClick(data) {
      if (this.isExecuteFlow) {
        this.updateItem(data, false);
      }
    },

    /**
     *  右矢印ボタン押下時の処理
     * @param {Object} data 値を変更した項目の情報
     */
    handleRightBtnClick(data) {
      if (this.isExecuteFlow) {
        this.updateItem(data);
      }
    },

    /**
     * 左矢印ボタン長押し時の処理
     * @param {Object} data 値を変更した項目の情報
     */
    handleLeftBtnHold(data) {
      if (this.isExecuteFlow) {
        this.updateItem(data, false, 10);
      }
    },

    /**
     * 右矢印ボタン長押し時の処理
     * @param {Object} data 値を変更した項目の情報
     */
    handleRightBtnHold(data) {
      if (this.isExecuteFlow) {
        this.updateItem(data, true, 10);
      }
    },

    /** 駆動ボタン押下時の処理 */
    driveBtn() {
      this.isDriving = !this.isDriving;
      if (this.isDriving) {
        this.drvBtnDisabled = true;
        // 駆動
        this.flow = FLOW.EXECUTE;
        this.$emit("toggle-drive", true);
        this.startDrive();
      }
    },

    /******************** 以下API ********************/
    /** 駆動開始処理 */
    async startDrive() {
      this.$emit("toggle-drive", true);
      this.flow = FLOW.EXECUTE;
      this.clearAtMsg();

      // マーカ登録処理(駆動開始時)
      const infos = [];
      this.items.forEach((item) => {
        const info = {
          "param": item.menu_title,
          "value": item.value
        };
        infos.push(info);
      });
      const markInfo = {
        "type": AT_EXE_TYPE.START,
        "info": infos
      };
      await this.$emit("save-active-test-executeMark", markInfo);

      // AT実行
      this.currentExecuteTime = Date.now();
      await (this.doStart(this.currentExecuteTime))();
    },

    /**
     * 駆動API通信開始
     * @param {Number} execTime 駆動開始時刻
     * @returns {Function} 駆動処理を実行する非同期関数
     */
    doStart(execTime) {
      return async () => {
        this.isStopping = false;

        // API実行パラメータ作成
        const token = session.getToken();
        // 更新データを送信
        const requestBody = this.genReqBodyStart(token.id_token);

        // start API実行
        const response = await atUtil.pollingAtApi(
          this,
          this.netAppId,
          this.systemId,
          this.activeTestId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => {
            errorType;
            atUtil.showUnexpectedError(this);
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => {
            atUtil.validateErrorResult(this, result);
          },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => {
            atUtil.validateErrorResult(this, result);
          },
          // GET API レスポンスチェックがin_progress時のコールバック
          () => {
            return config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
          },
          // GET API レスポンスチェックがcompleted時のコールバック
          (getApiResponse, self) => {
            if (atUtil.isErrorAbort(getApiResponse.data[PARAM.REQUEST_RESULT])) {
              // 開始のポーリングでCCエラー中断のレスポンスは、データモニタでエラーとなった場合のため、通信エラーへ遷移
              // ただしデータモニタ起点で既にエラー処理をおこなっている場合は、そのままポーリング終了
              if (!FLOW_ERROR.includes(this.flow)) {
                this.flow = FLOW.ERR;
                this.doErrorProcess(ERR_KEY.COMMUNICATION);
              }
              return config.INDIVIDUAL_POLLING_RESULT_FINISH;
            }

            const monitoringStatusData = atUtil.getMonitoringStatusData(getApiResponse.data[AT_EXE.USER_DATA]);
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            const isExeOnly =
              getApiResponse.data[AT_EXE.USER_DATA].length === 0 &&
              getApiResponse.data[AT_EXE.MNTR_STATUS] === MNTR_STATUS.COMPLETE;

            if (
              isExeOnly ||
              !(AT_EXE.MNTR_STATUS in getApiResponse.data) ||
              !getApiResponse.data[AT_EXE.MNTR_STATUS]
            ) {
              // 実行
              if (
                isExeOnly ||
                monitoringStatusData[AT_EXE.RES_TYPE] === RES_TYPE.OK
              ) {

                getApiResponse.data[AT_EXE.USER_DATA].some((x) => {
                  if (x.id !== 4783) {
                    return false;
                  }

                  if (x.res_type !== RES_TYPE.OK) {
                    // 通信エラーへ遷移
                    self.flow = FLOW.ERR_COMMUNICATE;
                    self.doErrorProcess(ERR_KEY.COMMUNICATION);
                    result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                    self.isDriving = false;
                    return true;
                  }

                  const value = x[AT_EXE.VAL].slice(6);
                  // value[1 or 2]: 0x0000 又は0xFFFFでない場合は、4.4.3.2.7.4.2 STATUS エラーへ遷移

                  const result_val = value.slice(0, 4).toUpperCase() /*await self.getWatchStatus()*/;
                  if ((result_val !== "0000") && (result_val !== "FFFF")) {
                    // STATUSエラーへ遷移
                    const atMsg = self.getStatusErrorMsg(self, value);
                    self.flow = FLOW.ERR_STATUS;
                    self.doErrorProcess(ERR_KEY.STATUS, atMsg);
                    result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                    self.isDriving = false;
                    return true;
                  }

                  // 正常終了
                  self.atMsgResult = result_val;
                  self.setAtMessage();
                  // 実行監視に遷移
                  self.flow = FLOW.CHECK_EXE;
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  return false;
                });

              } else {
                // 異常終了
                // 通信エラーへ遷移
                self.flow = FLOW.ERR_COMMUNICATE;
                self.doErrorProcess(ERR_KEY.COMMUNICATION);
                result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
              }
            } else {
              // 実行監視
              if (monitoringStatusData[AT_EXE.RES_TYPE] === RES_TYPE.OK) {
                // 正常終了
                if (!self.isStopping) {
                  // 実行監視に遷移
                  self.flow = FLOW.CHECK_EXE;
                }

                getApiResponse.data[AT_EXE.USER_DATA].some((x) => {
                  if (x.id !== 4783) {
                    return false;
                  }

                  if (x.res_type !== RES_TYPE.OK) {
                    // 通信エラーへ遷移
                    self.flow = FLOW.ERR_COMMUNICATE;
                    self.doErrorProcess(ERR_KEY.COMMUNICATION);
                    result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                    self.isDriving = false;
                    return true;
                  }

                  const value = x[AT_EXE.VAL].slice(6);
                  // value[1 or 2]: 0x0000 又は0xFFFFでない場合は、4.4.3.2.7.4.2 STATUS エラーへ遷移

                  const result_val = value.slice(0, 4).toUpperCase() /*await self.getWatchStatus()*/;
                  if ((result_val !== "0000") && (result_val !== "FFFF")) {
                    // STATUSエラーへ遷移
                    const atMsg = self.getStatusErrorMsg(self, value);
                    self.flow = FLOW.ERR_STATUS;
                    self.doErrorProcess(ERR_KEY.STATUS, atMsg);
                    result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                    self.isDriving = false;
                    return true;
                  }

                  // 正常終了
                  self.atMsgResult = result_val;
                  return false;
                });
                // 実行監視継続条件
                self.isDriving = false;
                if (self.isCurrentExecute(execTime, self)) {
                  // 駆動待ち
                  if (Object.keys(self.updateItems).length > 0) {
                    self.stopItems = self.updateItems;
                  }
                  self.updateItems = {};
                  self.drvBtnDisabled = true;
                }
                if (getApiResponse.data[AT_EXE.MNTR_STATUS] === MNTR_STATUS.COMPLETE) {
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                } else {
                  if (execTime === self.currentExecuteTime) {
                    self.setAtMessage();
                    result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  } else {
                    result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  }
                }
              } else {
                // 異常終了
                // 通信エラーへ遷移
                self.flow = FLOW.ERR_COMMUNICATE;
                self.doErrorProcess(ERR_KEY.COMMUNICATION);
                result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                self.isDriving = false;
              }
            }
            if (self.isStopping) {
              // 停止処理が開始されたのでstartのポーリングを終了させる
              result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
              self.isDriving = false;
            }
            return result;
          },
          // GET API レスポンスチェックがfailed時のコールバック
          (getApiResponse, self) => {
            // 共通エラーへ遷移
            self.flow = FLOW.ERR;
            self.doErrorProcess(ERR_KEY.COMMON);
          },
          () => { return ""; },
          Number.MAX_SAFE_INTEGER
        );

        return response;
      };
    },

    /**
     * 現在の駆動処理かどうかを判定する
     * @param {Number} execTime 駆動開始時刻
     * @param {Object} self thisオブジェクト
     * @returns {Boolean} 現在の駆動処理かどうか
     */
    isCurrentExecute(execTime, self) {
      if (execTime === self.currentExecuteTime) {
        if (self.latestUpdateTime < self.currentExecuteTime) {
          return true;
        }
      }
      return false;
    },

    /**
     * 駆動API通信停止
     */
    async doStop() {
      this.isStopping = true;

      // API実行パラメータ作成
      const token = session.getToken();
      const requestBody = this.genReqBodyStop(token.id_token);
      if (!requestBody) {
        return null;
      }

      // stop API実行
      const response = await atUtil.pollingAtApi(
        this,
        this.netAppId,
        this.systemId,
        this.activeTestId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => {
          errorType;
          atUtil.showUnexpectedError(this);
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => {
          atUtil.validateErrorResult(this, result);
        },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => {
          atUtil.validateErrorResult(this, result);
        },
        // GET API レスポンスチェックがin_progress時のコールバック
        () => {
          return config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
        },
        // GET API レスポンスチェックがcompleted時のコールバック
        (getApiResponse, self) => {
          getApiResponse;
          self;
          // 正常終了
          const result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
          return result;
        },
        // GET API レスポンスチェックがfailed時のコールバック
        (getApiResponse, self) => {
          getApiResponse;
          // 共通エラーへ遷移
          self.flow = FLOW.ERR;
          self.doErrorProcess(ERR_KEY.COMMON);
        }
      );

      return response;
    },

    /******************** エラー処理 ********************/
    /** 通信エラー画面処理 */
    async communicateError() {
      this.isStopping = true;

      // API実行パラメータ作成
      const token = session.getToken();
      const requestBody = this.genReqBodyStop(token.id_token, ERR_TYPE.COMMUNICATE);

      const response = await atUtil.pollingAtApi(
        this,
        this.netAppId,
        this.systemId,
        this.activeTestId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => {
          errorType;
          atUtil.showUnexpectedError(this);
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => {
          atUtil.validateErrorResult(this, result);
        },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => {
          atUtil.validateErrorResult(this, result);
        },
        // GET API レスポンスチェックがin_progress時のコールバック
        () => { },
        // GET API レスポンスチェックがcompleted時のコールバック
        (getApiResponse, self) => {
          const monitoringStatusData = atUtil.getMonitoringStatusData(getApiResponse.data[AT_EXE.USER_DATA]);
          let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
          const isStopOnly =
            getApiResponse.data[AT_EXE.USER_DATA].length === 0 &&
            getApiResponse.data[AT_EXE.MNTR_STATUS] === MNTR_STATUS.COMPLETE;
          if (
            isStopOnly ||
            !(AT_EXE.MNTR_STATUS in getApiResponse.data) ||
            !getApiResponse.data[AT_EXE.MNTR_STATUS]
          ) {
            // 停止
            if (
              isStopOnly ||
              monitoringStatusData[AT_EXE.RES_TYPE] === RES_TYPE.OK
            ) {
              // 正常終了
              atUtil.showUnexpectedError(
                this,
                ERR_KEY.COMMUNICATION,
                this.requirementId,
                null,
                async () => {
                  // STOP時にDefaultSession遷移実行しているため、doTerminateの実行不要
                  // await atUtil.doTerminate(this, true);
                  // 停止時に他の操作をさせないようにする
                  this.displayProcessing = true;
                  this.displayInit();
                  this.$emit('at-failure');
                  this.displayProcessing = false;
                }
              );
              result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
            } else {
              // 異常終了
              // 共通エラーへ遷移
              self.flow = FLOW.ERR;
              self.doErrorProcess(ERR_KEY.COMMON);
              result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
              self.isDriving = false;
            }
          }
          return result;
        },
        // GET API レスポンスチェックがfailed時のコールバック
        () => {
          // 共通エラーへ遷移
          self.flow = FLOW.ERR;
          self.doErrorProcess(ERR_KEY.COMMON);
        }
      );
      return response;
    },

    /**
     * STATUSエラー画面処理
     * @param {string} [atMsg=""] 表示するAT文言
     */
    async statusError(atMsg = "") {
      this.isStopping = true;
      // 駆動停止要求時にデフォルトセッション遷移を実行するため、その前に計測を停止する
      await new Promise((resolve) => {
        // 同期的に処理するために、resolveをstop-monitorイベントのコールバックで実行する
        this.$emit('stop-monitor', resolve);
      });

      // API実行パラメータ作成
      const token = session.getToken();
      const requestBody = this.genReqBodyStop(token.id_token, ERR_TYPE.STATUS);

      const response = await atUtil.pollingAtApi(
        this,
        this.netAppId,
        this.systemId,
        this.activeTestId,
        requestBody,
        // エラー発生のコールバック
        () => {
          // 異常終了: STATUSエラー画面表示
          this.showStatusError(atMsg);
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        () => {
          // 異常終了: STATUSエラー画面表示
          this.showStatusError(atMsg);
        },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        () => {
          // 異常終了: STATUSエラー画面表示
          this.showStatusError(atMsg);
        },
        // GET API レスポンスチェックがin_progress時のコールバック
        () => { },
        // GET API レスポンスチェックがcompleted時のコールバック
        (getApiResponse, self) => {
          let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
          const isStopOnly =
            getApiResponse.data[AT_EXE.USER_DATA].length === 0 &&
            getApiResponse.data[AT_EXE.MNTR_STATUS] === MNTR_STATUS.COMPLETE;
          if (
            isStopOnly ||
            !(AT_EXE.MNTR_STATUS in getApiResponse.data) ||
            !getApiResponse.data[AT_EXE.MNTR_STATUS]
          ) {
            // 停止
            let checkResponse = true;
            if (getApiResponse.data[AT_EXE.USER_DATA] && Array.isArray(getApiResponse.data[AT_EXE.USER_DATA])) {
              for (const userData of getApiResponse.data[AT_EXE.USER_DATA]) {
                if (userData.res_type !== RES_TYPE.OK) {
                  checkResponse = false;
                  break;
                }
              }
            }
            if (
              isStopOnly ||
              checkResponse
            ) {
              // 正常終了
              atUtil.showUnexpectedError(
                this,
                ERR_KEY.STATUS,
                this.requirementId,
                atMsg,
                async () => {
                  // STOP時にDefaultSession遷移実行しているため、doTerminateの実行不要
                  // await atUtil.doTerminate(this, true);
                  // 停止時に他の操作をさせないようにする
                  this.displayProcessing = true;
                  this.displayInit();
                  this.$emit('at-failure');
                  this.displayProcessing = false;
                }
              );
              result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
            } else {
              // 異常終了: STATUSエラー画面表示
              self.showStatusError(atMsg);
              result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
              self.isDriving = false;
            }
          }
          return result;
        },
        // GET API レスポンスチェックがfailed時のコールバック
        () => {
          // 異常終了: STATUSエラー画面表示
          this.showStatusError(atMsg);
        }
      );
      return response;
    },

    /**
     * STATUSエラー画面表示
     * @param {string} atMsg 表示するAT文言
     */
    showStatusError(atMsg) {
      atUtil.showUnexpectedError(
        this,
        ERR_KEY.STATUS,
        this.requirementId,
        atMsg,
        async () => {
          // 停止時に他の操作をさせないようにする
          this.displayProcessing = true;
          this.displayInit();
          this.$emit('at-failure');
          this.displayProcessing = false;
        }
      );
    },

    /** 共通エラー画面処理 */
    commonError() {
      // 共通エラーを表示
      atUtil.showUnexpectedError(
        this,
        ERR_KEY.COMMON,
        this.requirementId,
        null, // 共通エラーはnull
        async () => {
          // STOP時にDefaultSession遷移実行しているため、doTerminateの実行不要
          // await atUtil.doTerminate(this, true);
          // 停止時に他の操作をさせないようにする
          this.displayProcessing = true;
          this.displayInit();
          this.$emit('at-failure');
          this.displayProcessing = false;
        }
      );
    },

    /** 
     * エラー処理の振り分け
     * @param {*} errKey エラーキー
     * @param {string} [atMsg=""] STATUSエラーで表示するAT文言
     */
    async doErrorProcess(errKey, atMsg = "") {
      switch (errKey) {
        case ERR_KEY.COMMUNICATION:
          await this.communicateError();
          break;
        case ERR_KEY.STATUS:
          await this.statusError(atMsg);
          break;
        case ERR_KEY.COMMON:
        default:
          this.commonError();
          break;
      }
    },

    /**
     * 駆動開始リクエストボディ生成
     * @param {string} idToken IDトークン
     * @returns {Object} リクエストボディ
     */
    genReqBodyStart(idToken) {
      const self = this;
      const dids = [];
      const ctrls = [];

      Object.keys(self.updateItems).forEach((did) => {
        if (self.updateItems[did].name) {
          dids.push(did);
          ctrls.push("FF");
          return;
        }
        const conv = self.conversionInfoList.find((x) => x.did === did);
        let tmp = self.updateItems[did].upd;
        if (("data_type" in conv.info) && (conv.info.data_type === DATA_TYPE.HEX)) {
          const currentIndex = self.didList[did].i18n.values.findIndex((x) => (tmp === x.val));
          tmp = self.didList[did].i18n.values[currentIndex].val;
        }

        dids.push(self.didList[did].sid0x2E_sid0x2F[0]);
        if (("data_type" in conv.info) && (conv.info.data_type === DATA_TYPE.VAL)) {
          // SI単位系の値から算出する
          tmp = self.updateItems[did].siVal;
          ctrls.push(atUtil.convertValueToHex(tmp, conv));
        } else {
          const padSize = conv.info[PARAM.BYTE_SIZE] * 2;
          tmp = tmp.toString(16).toUpperCase().padStart(padSize, "0");

          // リトルエンディアンの場合はバイト反転
          if (conv.info[PARAM.LITTLE_ENDIAN]) {
            tmp = atUtil.reverseBytes(tmp, conv);
          }

          if (conv.info.data_type === DATA_TYPE.FLG) {
            if (tmp !== ("0".repeat(padSize))) {
              tmp = "F".repeat(padSize);
            }
          }
          ctrls.push(tmp);
        }
      });

      const request = {
        id_token: idToken,
        did: dids,
        control_state: ctrls,
        type: API_TYPE.START,
      };
      return request;
    },

    /**
     * 駆動停止リクエストボディ生成
     * @param {string} idToken IDトークン
     * @param {string} [errType=""] エラータイプ
     * @returns {Object} リクエストボディ
     */
    genReqBodyStop(idToken, errType = "") {

      const self = this;
      const dids = [];
      const stopTargets = (Object.keys(self.updateItems).length > 0) ?
        self.updateItems : self.stopItems;

      Object.keys(stopTargets).forEach((did) => {
        if (stopTargets[did].name) {
          dids.push(did);
          return;
        }
        dids.push(self.didList[did].sid0x2E_sid0x2F[0]);
      });

      if (dids.length <= 0) {
        return null;
      }

      const request = {
        id_token: idToken,
        did: dids,
        type: API_TYPE.STOP,
      };
      switch (errType) {
        case ERR_TYPE.COMMUNICATE:
        case ERR_TYPE.STATUS:
          request.error_type = errType;
          break;
        default:
          break;
      }
      return request;
    },

    /** 初期化処理 */
    displayInit() {
      // 初期化
      this.isDriving = false;
      this.flow = FLOW.INIT;
      this.$emit("toggle-drive", false);
    },

    /**
     * モニタリングステータス取得
     * @returns {string} ステータス値
     */
    async getWatchStatus() {
      const self = this;
      const dataRes = await atUtil.doRead(self, ["12AF"]);
      const monitoringStatusData = atUtil.getMonitoringStatusData(dataRes.data[AT_EXE.USER_DATA]);

      const value = monitoringStatusData[AT_EXE.VAL].slice(6);
      // value[1 or 2]: 0x0000 又は0xFFFFでない場合は、4.4.3.2.7.4.2 STATUS エラーへ遷移
      return value.slice(0, 4).toUpperCase();
    },

    /**
     * 駆動中かどうかを判定
     * @returns {Boolean} 駆動中かどうか
     */
    checkDriving() {
      return this.isDriving;
    },

    /**
     * 翻訳ファイルからdidに対応した表示値リストを取得
     * @param {*} conversionInfo
     * @returns {Array} [{label:触媒前導入, val:1}]
     */
    getDidI18nList(conversionInfo) {
      const did = conversionInfo[PARAM.DID];
      const data_type = conversionInfo.info[PARAM.TYPE];
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const findFFDi18nKey = individualDiagnose.getFFDi18nKey(this, this.individualMenus ? this.individualMenus.menu_list : []);
      const list = [];

      if (DATA_TYPE.HEX === data_type) {
        const dataLen = 16 ** this.byteSize(conversionInfo);
        // バイト数だけ取得
        for (let dec = 0; dec <= dataLen; dec++) {
          // 表示範囲外の場合は次へ
          if (
            dec < conversionInfo.info[PARAM.OPERATION_RULES].min ||
            conversionInfo.info[PARAM.OPERATION_RULES].max < dec
          ) {
            continue;
          }

          const hexKey = dec
            .toString(16)
            .toUpperCase()
            .padStart(this.byteSize(conversionInfo) * 2, "0");

          // diag/配下の検索キー
          const key = `${findFFDi18nKey}.${did}_${hexKey}`;
          // at/did/配下の検索キー
          const keyAt = `atDid${systemId}.${did}_${hexKey}`;

          if (this.$te(key)) {
            list.push({ label: this.$t(key), val: dec });
          } else if (this.$te(keyAt)) {
            list.push({ label: this.$t(keyAt), val: dec });
          } else {
            // 翻訳が取得できなかった場合は、HEX値を直接表示
            list.push({ label: `${HEX_PREFIX}${hexKey}`, val: dec });
          }
        }

      } else if (DATA_TYPE.FLG === data_type) {
        // did_00を取得
        // diag/配下の検索キー
        const key0 = `${findFFDi18nKey}.${did}_${"00"}`;
        // at/did/配下の検索キー
        const key0At = `atDid${systemId}.${did}_${"00"}`;

        if (this.$te(key0)) {
          list.push({ label: this.$t(key0), val: 0 });
        } else if (this.$te(key0At)) {
          list.push({ label: this.$t(key0At), val: 0 });
        }

        // did_FFを取得
        // diag/配下の検索キー
        const keyFF = `${findFFDi18nKey}.${did}_${"FF"}`;
        // at/did/配下の検索キー
        const keyFFAt = `atDid${systemId}.${did}_${"FF"}`;

        if (this.$te(keyFF)) {
          list.push({ label: this.$t(keyFF), val: this.byteSize(conversionInfo) });
        } else if (this.$te(keyFFAt)) {
          list.push({ label: this.$t(keyFFAt), val: this.byteSize(conversionInfo) });
        }
      }

      return {
        values: list,
      };
    },

    /**
     * バイトサイズを取得
     * @param {Object} conversion 変換情報
     * @returns {Number} バイトサイズ
     */
    byteSize(conversion) {
      return conversion.info.byte_or_bit === "byte"
        ? conversion.info.byte_size
        : Math.ceil(conversion.info.bit_size / 8);
    },

    /** テーブルのカラムを設定 */
    setColumns() {
      const columns = [
        {
          name: PARAM.TITLE,
          label: this.$t("individual.header_work_support_table_item"),
          useHtmlBind: true
        },
        {
          name: "value",
          label: this.$t("individual.header_customize_write_settings"),
          useHtmlBind: true,
          settingButton: true,
          //          useButton: true,
        },
        {
          name: "unit",
          label: this.$t("individual.label_detail_unit"),
          useHtmlBind: true
        },
      ];

      this.columns = columns;
    },

    /** AT表示文言を設定 */
    setAtMessage() {
      if (!this.atMsgResult) {
        this.clearAtMsg();
        return;
      }
      const atMsg = "at" + this.systemId + ".999999.STATUS_" + String(parseInt(this.atMsgResult, 16));
      this.message = this.$te(atMsg) ? this.$t(atMsg) : atMsg;
    },

    /** 
     * ステータスエラーメッセージを取得
     * @param {Object} self 呼び出し元インスタンス
     * @param {String} value ステータス値
     * @returns {String} エラーメッセージ
     */
    getStatusErrorMsg(self, value) {
      const x12 = value.slice(0, 4).toUpperCase();
      const ecuKey = "at" + self.systemId + ".999999.STATUS_";
      let atMsg = self.$t("individual.error_active_test_pre") + "\n";
      if (x12.slice(0, 2) === "41") {
        const v1 = parseInt(x12.slice(2, 4), 16);
        if ((v1 >= parseInt("00", 16)) && (v1 <= parseInt("19", 16))) {
          const msg = (ecuKey + String(parseInt(x12, 16)));
          atMsg += ((self.$te(msg) ? self.$t(msg) : msg) + "\n");
        } else if ((v1 >= parseInt("26", 16)) && (v1 <= parseInt("30", 16))) {
          const msg = (ecuKey + String(parseInt(x12, 16)));
          atMsg += ((self.$te(msg) ? self.$t(msg) : msg) + "\n");
        } else if ((v1 >= parseInt("34", 16)) && (v1 <= parseInt("38", 16))) {
          const msg = (ecuKey + String(parseInt(x12, 16)));
          atMsg += ((self.$te(msg) ? self.$t(msg) : msg) + "\n");
        } else {
          atMsg += "\n";
        }
      }
      const x34 = value.slice(4, 8).toUpperCase();
      const v0 = parseInt(x34.slice(0, 2), 16);
      if (v0 === parseInt("00", 16)) {
        const v1 = parseInt(x34.slice(2, 4), 16);
        if ((v1 >= parseInt("00", 16)) && (v1 <= parseInt("02", 16))) {
          const msg = (ecuKey + String(parseInt(x34, 16)));
          atMsg += ((self.$te(msg) ? self.$t(msg) : msg) + "\n");
        } else if ((v1 >= parseInt("10", 16)) && (v1 <= parseInt("11", 16))) {
          const msg = (ecuKey + String(parseInt(x34, 16)));
          atMsg += ((self.$te(msg) ? self.$t(msg) : msg) + "\n");
        } else {
          atMsg += "\n";
        }
      } else if (v0 === parseInt("41", 16)) {
        const v1 = parseInt(x34.slice(2, 4), 16);
        if ((v1 >= parseInt("20", 16)) && (v1 <= parseInt("25", 16))) {
          const msg = (ecuKey + String(parseInt(x34, 16)));
          atMsg += ((self.$te(msg) ? self.$t(msg) : msg) + "\n");
        } else {
          atMsg += "\n";
        }
      }
      return atMsg;
    },

    /** 実行をキャンセル */
    async cancelExec() {
      this.currentExecuteTime = null;
      // 駆動中であれば停止する。ただし他のエラー処理を既に実行していれば何もしない
      if (this.isDriveFlow && !FLOW_ERROR.includes(this.flow) && !this.isStopping) {
        await this.doStop();
      }
    },

    /** サインアウトを設定 */
    setSignout() {
      this.signout = true;
    },

  },

  mounted() {
    this.drvBtnDisabled = true;
    this.setColumns();
  },
};
